import Repository from "./Repository";
import LocalRepository from "./LocalRepository";

export default {

    loginFB (access_token) {
        return Repository.new().get("/auth/facebook", {access_token: access_token});
    },
    loginGoogle (access_token) {
        return Repository.new().get("/auth/google", {access_token: access_token});
    },
    login (cif, password) {
        return Repository.new().post("/login", {cif: cif, password: password});
    },

    saveSocket (socket) {
        return Repository.new().post("/save-socket", {socket: socket});
    },

    register (cif, email, password, name) {
        return Repository.new().post('/register', {cif: cif, email: email, password: password, name: name});
    },
    validate (token) {
        return Repository.new().post('/validate', {tokenValidated: token});
    },

    resetPass (email) {
        return Repository.new().post('/resetPassword', {email: email});
    },

    changePass (password, token) {
        return Repository.new().post('/changePassword', {password: password, token: token});
    },

    getAllUrlParams (url) {
        let queryString = url ? url.split('?')[1] : window.location.search.slice(1);
        const obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            const arr = queryString.split('&');
            for (const element of arr) {
                const a = element.split('=');
                let paramName = a[0];
                let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
                paramName = paramName.toLowerCase();
                if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();
                if (paramName.match(/\[(\d+)?\]$/)) {
                    const key = paramName.replace(/\[(\d+)?\]/, '');
                    if (!obj[key]) obj[key] = [];
                    if (paramName.match(/\[\d+\]$/)) {
                        const index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        obj[key].push(paramValue);
                    }
                } else if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
        return obj;
    },

    async getMe (token = null) {
        try {
            const params = this.getAllUrlParams(false);
            let response = null;
            if (token) {
                response = await Repository.new().auth(token).get("/auth");
            } else if (LocalRepository.has('token')) {
                response = await Repository.new().get("/auth");
            }
            if (response && response.data && !params.logintoken) {
                return response.data.user;
            } else if (params.logintoken) {
                response = await Repository.new().post("/unlogged-user", {loginToken: params.logintoken});
                if (response && response.data) {
                    LocalRepository.set('token', response.data.token);
                    return response.data.user;
                }
            }
        } catch (ignored) {
            return null;
        }
        return null;
    },

    saveSubscription (subs) {
        return Repository.new().post("/save-subscription", {subscription: subs});
    },

};
